export default {
  eyebrow: 'Kumppaniportaali',
  title: 'Vero ja valuutta',
  description: 'Oletusverokategoriat, jotka ravintolasi perivät, ellei kategoriaa ohiteta erikseen.',
};
